<template>
  <div :id="id"/>
</template>

<script>
import ApexCharts from 'apexcharts'

export default {
  name: 'ApexBarChart',
  props: {
    series: {
      type: Array,
      required: true,
    },
    categories: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      id: 'chart'+this._uid,
      chart: null
    }
  },

  watch: {
    series() {
      // BarCharts.vueで取得した集計用データの変更を監視し、グラフにリアルタイム反映を行う
      this.chart.updateSeries(this.series)
    }
  },

  mounted() {
    // categories[0]が5文字じゃないものは5文字に合わせる
    if (this.categories[0].lenght !== 5) {
      this.categories[0] = (this.categories[0] + "　　　　　　　").slice(0, 5)
    }
    this.createChart();
  },

  methods: {
    createChart() {
      var options = {
        colors:[ //https://apexcharts.com/docs/options/theme/ の色を使用（これで５０色まで対応できている）
          '#008FFB', '#00E396', '#FEB019', '#FF4560', '#775DD0',
          '#3F51B5', '#4CAF50', '#F9CE1D', '#FF9800', '#33B2DF',
          '#03A9F4', '#546E7A', '#D4526E', '#13D8AA', '#A5978B',
          '#4ECDC4', '#C7F464', '#81D4FA', '#546E7A', '#FD6A6A',
          '#2B908F', '#F9A3A4', '#90EE7E', '#FA4443', '#69D2E7',
          '#449DD1', '#F86624', '#EA3546', '#662E9B', '#C5D86D',
          '#D7263D', '#1B998B', '#2E294E', '#F46036', '#E2C044',
          '#662E9B', '#F86624', '#F9C80E', '#EA3546', '#43BCCD',
          '#5C4742', '#A5978B', '#8D5B4C', '#5A2A27', '#C4BBAF',
          '#A300D6', '#7D02EB', '#5653FE', '#2983FF', '#00B1F2',
        ],
        series: this.series,
        chart: {
          type: 'bar',
          height: 140,
          width: '100%',
          stacked: true,
          stackType: '100%',
          toolbar: {
            show: false
          },
        },
        plotOptions: {
          bar: {
            horizontal: true,
          },
        },
        stroke: {
          width: 1,
          colors: ['#fff']
        },
        xaxis: {
          categories: this.categories,
          labels: {
            formatter: function (val) {
              return val + '%';
            }
          }
        },
        yaxis: {
          title: {
            text: undefined
          },
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val + "%"
            }
          }
        },
        legend: {
          show: true,
          height: 50,
          horizontalAlign: 'left',
          offsetX: 48,
          onItemClick: {
            toggleDataSeries: false //動的にグラフのデータを変更しない
          },
        },
      };

      this.chart = new ApexCharts(document.querySelector("#"+this.id), options);
      this.chart.render();
    }
  }
}
</script>
